import React from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import green from "@material-ui/core/colors/green";
import blue from "@material-ui/core/colors/blue";
import orange from "@material-ui/core/colors/orange";
import red from "@material-ui/core/colors/red";

const theme = createMuiTheme();

const colors = [
  "rgba(51, 204, 0, 0.9)", // waterstone green
  "rgba(243, 112, 70, 1)", // orange
  "rgba(26, 188, 156, 1)", // sea green
  "rgba(0, 155, 144, 1)", // checkers green
  "rgba(52, 73, 94, 1)", // onyx
  "rgba(231, 76, 60, 1)" // ruby red
];
const primaryColor = colors[Math.floor(Math.random() * colors.length)];

const overrides = {
  App: {
    toolbar: {
      minHeight: 54
    }
  },
  MuiSkeleton: {
    text: {
      marginTop: 0,
      marginBottom: 0
    }
  },
  MuiFormControlLabel: {
    labelPlacementStart: {
      marginLeft: 0
    }
  },
  MuiTableCell: {
    root: {
      padding: theme.spacing(1.5)
    },
    head: {
      lineHeight: 1
    }
  },
  MuiListItemIcon: {
    root: {
      minWidth: theme.spacing(4.5)
    }
  },
  MuiInput: {
    underline: {
      "&:before": {
        borderBottom: "1px solid rgba(169, 169, 169, 1)"
      },
      "&:hover:not($disabled):not($focused):not($error):before": {
        borderBottom: "1px solid rgba(169, 169, 169, 1)"
      }
    }
  },
  MuiToolbar: {
    root: {
      background: "rgba(0, 0, 0, 0.9)",
      color: "#fff",
      "@media (min-width: 600px)": {
        minHeight: "54px"
      }
    },
    regular: {
      minHeight: "54px"
    },
    dense: {
      minHeight: "54px"
    },
    gutters: {
      "@media (min-width: 600px)": {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
      }
    }
  },
  MuiTablePagination: {
    toolbar: {
      background: theme.palette.grey[50],
      color: theme.palette.text.primary
    }
  },
  MuiButtonGroup: {
    root: {
      borderRadius: 0
    },
    groupedContainedSecondary: {
      borderRight: "0 !important"
    }
  },
  MuiIconButton: {
    root: {
      padding: theme.spacing() * 0.75
    }
  },
  MuiChip: {
    outlined: {
      "&:hover": {
        backgroundColor: `${primaryColor} !important`,
        color: "#fff",
        "& svg": {
          color: "#fff"
        }
      }
    }
  },
  MuiList: {
    padding: {
      paddingTop: 0,
      paddingBottom: 0
    }
  }
  // PrivateSwitchBase: {
  //   root: {
  //     paddingTop: 3,
  //     paddingBottom: 3
  //   }
  // }
};

// A theme with custom primary and secondary color.
// It's optional.
export const defaultTheme = createMuiTheme({
  shape: {
    borderRadius: 2
  },
  palette: {
    primary: {
      // light: 'rgba(51, 204, 0, 0.9)',
      // main: 'rgba(51, 204, 0, 0.9)',
      // dark: 'rgba(51, 204, 0, 0.9)',
      light: primaryColor,
      main: primaryColor,
      dark: primaryColor,
      contrastText: "#fff"
    },
    secondary: {
      light: "#eee", // green[300],
      main: "#ccc", // green[500],
      dark: "#212121", // green[700]
      contrastText: "#fff"
    },
    error: {
      light: red[200],
      main: red[400],
      dark: red[500]
    },
    info: {
      light: blue[200],
      main: blue[400],
      dark: blue[500]
    },
    success: {
      light: green[200],
      main: green[400],
      dark: green[500]
    },
    warning: {
      light: orange[200],
      main: orange[400],
      dark: orange[500]
    }
  },
  overrides: {
    ...overrides
  }
  // mixins: {
  //   toolbar: {
  //     minHeight: 54,
  //     '@media (min-width: 0px) and (orientation: landscape)': {
  //       minHeight: 54
  //     },
  //     '@media (min-width: 600px)': {
  //       minHeight: 54
  //     }
  //   }
  // },
  // overrides: {
  //   MuiToolbar: {
  //     root: {
  //       minHeight: '54px',
  //       background: 'rgba(0, 0, 0, 0.9)',
  //       color: '#fff',
  //       '@media (min-width: 600px)': {
  //         minHeight: '54px'
  //       }
  //     },
  //     gutters: {
  //       '@media (min-width: 600px)': {
  //         paddingLeft: 16,
  //         paddingRight: 16
  //       }
  //     }
  //   },
  //   MuiInput: {
  //     underline: {
  //       '&:hover:not($disabled):not($focused):not($error):before': {
  //         //underline color when hovered
  //         borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
  //       }
  //     }
  //   },
  //   MuiButton: {
  //     contained: {
  //       boxShadow:
  //         'rgba(0, 0, 0, 0.24) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 0px 2px 0px;',
  //       borderRadius: 2
  //     }
  //   },
  //   MuiIconButton: {
  //     root: {
  //       width: 32,
  //       height: 32
  //     }
  //   }
  // }
});

function themeProvider(Component) {
  return function WithRoot(props) {
    return (
      <MuiThemeProvider theme={defaultTheme}>
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    );
  };
}

const darkTheme = createMuiTheme({
  palette: {
    shape: {
      borderRadius: 2
    },
    type: "dark",
    primary: {
      light: primaryColor,
      main: primaryColor,
      dark: primaryColor,
      // light: 'rgba(51, 204, 0, 0.9);',
      // main: 'rgba(51, 204, 0, 0.9);',
      // dark: 'rgba(51, 204, 0, 0.9);',
      contrastText: "#fff"
    }
  }
});

export const DefaultTheme = props => (
  <MuiThemeProvider theme={defaultTheme}>
    <CssBaseline />
    {props.children}
  </MuiThemeProvider>
);

export const DarkTheme = props => (
  <MuiThemeProvider theme={darkTheme}>{props.children}</MuiThemeProvider>
);

export default themeProvider;
